

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Decode
// ====================================================

export interface Decode_decode_styles {
  provider: string | null;
  styleId: string | null;
  title: string | null;
  series: string | null;
}

export interface Decode_decode {
  vin: string | null;
  year: number | null;
  make: string | null;
  model: string | null;
  styles: (Decode_decode_styles | null)[] | null;
}

export interface Decode {
  decode: Decode_decode | null;
}

export interface DecodeVariables {
  vin: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetrieveSubmissions
// ====================================================

export interface RetrieveSubmissions_submissions_decode_valuations {
  avg: number | null;
  clean: number | null;
  rough: number | null;
  xclean: number | null;
}

export interface RetrieveSubmissions_submissions_decode_valuationsByMileage_conditionValues {
  xclean: number | null;
  clean: number | null;
  avg: number | null;
  rough: number | null;
}

export interface RetrieveSubmissions_submissions_decode_valuationsByMileage {
  rangeBegin: number | null;
  rangeEnd: number | null;
  conditionValues: RetrieveSubmissions_submissions_decode_valuationsByMileage_conditionValues | null;
}

export interface RetrieveSubmissions_submissions_decode {
  vin: string | null;
  year: number | null;
  make: string | null;
  model: string | null;
  provider: string | null;
  styleId: string | null;
  styleName: string | null;
  vehiclePhoto: string | null;
  valuations: RetrieveSubmissions_submissions_decode_valuations | null;                               // Base valuation for the car
  valuationsByMileage: (RetrieveSubmissions_submissions_decode_valuationsByMileage | null)[] | null;  // Valuations based on mileage ranges and condition
}

export interface RetrieveSubmissions_submissions_questionGroups_questions_answer {
  code: string | null;
  value: string;
  default: boolean | null;
  extra: (string | null)[] | null;
  type: string | null;
}

export interface RetrieveSubmissions_submissions_questionGroups_questions_options {
  code: string;
  value: string;
  default: boolean;
  extra: (string | null)[] | null;
}

export interface RetrieveSubmissions_submissions_questionGroups_questions_imagesPlaceholders {
  name: string;
  url: string;
}

export interface RetrieveSubmissions_submissions_questionGroups_questions_imagesPlaceholdersForCamera {
  name: string;
  url: string;
}

export interface RetrieveSubmissions_submissions_questionGroups_questions {
  answer: (RetrieveSubmissions_submissions_questionGroups_questions_answer | null)[] | null;
  title: string;
  key: string;
  type: QuestionType;
  displayRule: string | null;
  validationRule: string | null;
  requiresAnswer: boolean;
  coachNote: string | null;       // Displays extra information about the question
  answerTitle: string | null;     // Title of the question when answered
  answerFunction: string | null;  // Function that will be triggered when answering the question
  options: (RetrieveSubmissions_submissions_questionGroups_questions_options | null)[] | null;
  imagesPlaceholders: (RetrieveSubmissions_submissions_questionGroups_questions_imagesPlaceholders | null)[] | null;
  imagesPlaceholdersForCamera: (RetrieveSubmissions_submissions_questionGroups_questions_imagesPlaceholdersForCamera | null)[] | null;
}

export interface RetrieveSubmissions_submissions_questionGroups {
  title: string;
  key: string | null;
  displayRule: string | null;
  editable: boolean;
  category: string | null;               // Category to group a set of question groups
  requiresConfirmation: boolean | null;  // Continue or cancel current vehicle creation process
  questions: (RetrieveSubmissions_submissions_questionGroups_questions | null)[] | null;
}

export interface RetrieveSubmissions_submissions {
  id: string | null;
  type: string | null;
  decode: RetrieveSubmissions_submissions_decode | null;
  questionGroups: (RetrieveSubmissions_submissions_questionGroups | null)[] | null;
}

export interface RetrieveSubmissions {
  submissions: (RetrieveSubmissions_submissions | null)[] | null;
}

export interface RetrieveSubmissionsVariables {
  externalId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetrieveAllSubmissions
// ====================================================

export interface RetrieveAllSubmissions_findAllByUserId {
  id: string | null;
  externalId: string | null;
}

export interface RetrieveAllSubmissions {
  findAllByUserId: (RetrieveAllSubmissions_findAllByUserId | null)[] | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Structure
// ====================================================

export interface Structure_structure_decode_valuations {
  avg: number | null;
  clean: number | null;
  rough: number | null;
  xclean: number | null;
}

export interface Structure_structure_decode_valuationsByMileage_conditionValues {
  xclean: number | null;
  clean: number | null;
  avg: number | null;
  rough: number | null;
}

export interface Structure_structure_decode_valuationsByMileage {
  rangeBegin: number | null;
  rangeEnd: number | null;
  conditionValues: Structure_structure_decode_valuationsByMileage_conditionValues | null;
}

export interface Structure_structure_decode {
  vin: string | null;
  year: number | null;
  make: string | null;
  model: string | null;
  provider: string | null;
  styleId: string | null;
  styleName: string | null;
  vehiclePhoto: string | null;
  valuations: Structure_structure_decode_valuations | null;                               // Base valuation for the car
  valuationsByMileage: (Structure_structure_decode_valuationsByMileage | null)[] | null;  // Valuations based on mileage ranges and condition
}

export interface Structure_structure_questionGroups_questions_answer {
  code: string | null;
  value: string;
  default: boolean | null;
  extra: (string | null)[] | null;
  type: string | null;
}

export interface Structure_structure_questionGroups_questions_options {
  code: string;
  value: string;
  default: boolean;
  extra: (string | null)[] | null;
}

export interface Structure_structure_questionGroups_questions_imagesPlaceholders {
  name: string;
  url: string;
}

export interface Structure_structure_questionGroups_questions_imagesPlaceholdersForCamera {
  name: string;
  url: string;
}

export interface Structure_structure_questionGroups_questions {
  answer: (Structure_structure_questionGroups_questions_answer | null)[] | null;
  title: string;
  key: string;
  type: QuestionType;
  displayRule: string | null;
  validationRule: string | null;
  requiresAnswer: boolean;
  coachNote: string | null;       // Displays extra information about the question
  answerTitle: string | null;     // Title of the question when answered
  answerFunction: string | null;  // Function that will be triggered when answering the question
  options: (Structure_structure_questionGroups_questions_options | null)[] | null;
  imagesPlaceholders: (Structure_structure_questionGroups_questions_imagesPlaceholders | null)[] | null;
  imagesPlaceholdersForCamera: (Structure_structure_questionGroups_questions_imagesPlaceholdersForCamera | null)[] | null;
}

export interface Structure_structure_questionGroups {
  title: string;
  key: string | null;
  displayRule: string | null;
  editable: boolean;
  category: string | null;               // Category to group a set of question groups
  requiresConfirmation: boolean | null;  // Continue or cancel current vehicle creation process
  questions: (Structure_structure_questionGroups_questions | null)[] | null;
}

export interface Structure_structure {
  decode: Structure_structure_decode | null;
  questionGroups: (Structure_structure_questionGroups | null)[] | null;
}

export interface Structure {
  structure: Structure_structure | null;
}

export interface StructureVariables {
  vin: string;
  style: StyleInput;
  type?: string | null;
  preloadedAnswers?: (preloadedAnswersInput | null)[] | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: Mutation
// ====================================================

export interface Mutation_submit {
  id: string | null;
  externalId: string | null;
}

export interface Mutation {
  submit: Mutation_submit | null;
}

export interface MutationVariables {
  structure: StructureInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditSubmission
// ====================================================

export interface EditSubmission_editSubmission {
  id: string | null;
  externalId: string | null;
}

export interface EditSubmission {
  editSubmission: EditSubmission_editSubmission | null;
}

export interface EditSubmissionVariables {
  structure: StructureInput;
  externalId: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DecodeAttributes
// ====================================================

export interface DecodeAttributes_valuations {
  avg: number | null;
  clean: number | null;
  rough: number | null;
  xclean: number | null;
}

export interface DecodeAttributes_valuationsByMileage_conditionValues {
  xclean: number | null;
  clean: number | null;
  avg: number | null;
  rough: number | null;
}

export interface DecodeAttributes_valuationsByMileage {
  rangeBegin: number | null;
  rangeEnd: number | null;
  conditionValues: DecodeAttributes_valuationsByMileage_conditionValues | null;
}

export interface DecodeAttributes {
  vin: string | null;
  year: number | null;
  make: string | null;
  model: string | null;
  provider: string | null;
  styleId: string | null;
  styleName: string | null;
  vehiclePhoto: string | null;
  valuations: DecodeAttributes_valuations | null;                               // Base valuation for the car
  valuationsByMileage: (DecodeAttributes_valuationsByMileage | null)[] | null;  // Valuations based on mileage ranges and condition
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuestionGroupAttributes
// ====================================================

export interface QuestionGroupAttributes {
  title: string;
  key: string | null;
  displayRule: string | null;
  editable: boolean;
  category: string | null;               // Category to group a set of question groups
  requiresConfirmation: boolean | null;  // Continue or cancel current vehicle creation process
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuestionAttributes
// ====================================================

export interface QuestionAttributes_answer {
  code: string | null;
  value: string;
  default: boolean | null;
  extra: (string | null)[] | null;
  type: string | null;
}

export interface QuestionAttributes_options {
  code: string;
  value: string;
  default: boolean;
  extra: (string | null)[] | null;
}

export interface QuestionAttributes_imagesPlaceholders {
  name: string;
  url: string;
}

export interface QuestionAttributes_imagesPlaceholdersForCamera {
  name: string;
  url: string;
}

export interface QuestionAttributes {
  answer: (QuestionAttributes_answer | null)[] | null;
  title: string;
  key: string;
  type: QuestionType;
  displayRule: string | null;
  validationRule: string | null;
  requiresAnswer: boolean;
  coachNote: string | null;       // Displays extra information about the question
  answerTitle: string | null;     // Title of the question when answered
  answerFunction: string | null;  // Function that will be triggered when answering the question
  options: (QuestionAttributes_options | null)[] | null;
  imagesPlaceholders: (QuestionAttributes_imagesPlaceholders | null)[] | null;
  imagesPlaceholdersForCamera: (QuestionAttributes_imagesPlaceholdersForCamera | null)[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum QuestionType {
  address = "address",
  currency = "currency",
  date = "date",
  gallery = "gallery",
  media = "media",
  medianote = "medianote",
  multiselect = "multiselect",
  note = "note",
  singlemultiselect = "singlemultiselect",
  singleselect = "singleselect",
  units = "units",
}

// null
export interface StyleInput {
  provider?: string | null;
  styleId?: string | null;
}

// Allows to pre-load answers for specific questions
export interface preloadedAnswersInput {
  answer?: (AnswerInput | null)[] | null;
  questionKey: string;
}

// null
export interface AnswerInput {
  code?: string | null;
  default?: boolean | null;
  extra?: (string | null)[] | null;
  type?: string | null;
  value: string;
}

// null
export interface StructureInput {
  decode?: DecodeInput | null;
  questionGroups?: (QuestionGroups | null)[] | null;
  type?: string | null;
}

// null
export interface DecodeInput {
  make?: string | null;
  model?: string | null;
  provider?: string | null;
  styleId?: string | null;
  styleName?: string | null;
  valuations?: VehicleConditionValuationInput | null;
  valuationsByMileage?: (MileageValuationInput | null)[] | null;
  vin?: string | null;
  year?: number | null;
}

// null
export interface VehicleConditionValuationInput {
  avg?: number | null;
  clean?: number | null;
  rough?: number | null;
  xclean?: number | null;
}

// null
export interface MileageValuationInput {
  conditionValues?: VehicleConditionValuationInput | null;
  rangeBegin?: number | null;
  rangeEnd?: number | null;
}

// null
export interface QuestionGroups {
  category?: string | null;
  displayRule?: string | null;
  editable?: boolean | null;
  key?: string | null;
  questions?: (QuestionInput | null)[] | null;
  requiresConfirmation?: boolean | null;
  title?: string | null;
}

// null
export interface QuestionInput {
  answer?: (AnswerInput | null)[] | null;
  answerFunction?: string | null;
  answerTitle?: string | null;
  coachNote?: string | null;
  displayRule?: string | null;
  imagesPlaceholders?: (ImageInput | null)[] | null;
  imagesPlaceholdersForCamera?: (ImageInput | null)[] | null;
  key?: string | null;
  options?: (OptionInput | null)[] | null;
  requiresAnswer: boolean;
  title?: string | null;
  type?: QuestionType | null;
  validationRule?: string | null;
}

// null
export interface ImageInput {
  name: string;
  url: string;
}

// null
export interface OptionInput {
  code?: string | null;
  default?: boolean | null;
  extra?: (string | null)[] | null;
  value: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================